/* eslint-disable react/jsx-pascal-case */
import React from "react";
import Header from "../components/Layouts/Header";

import Hero from "../components/Layouts/Hero";
import Footer from "../components/Layouts/Footer";
import About from "../components/Layouts/About";
import Feature from "../components/Layouts/Feature";
import Faq from "../components/Layouts/Faq";

const homePage = () => {
  return (
    <>
      <Header />
      <Hero />
      <About />
      <Feature />
      <Faq />
      <Footer />
    </>
  );
};

export default homePage;
